// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@guestsupply/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { summaryTableStyles } from "@guestsupply/Overrides/Widgets/InvoiceDetails/InvoiceDetailsSummaryTable";
import { color } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

summaryTableStyles.lineHeader = {
    wrapper: {
        css: css`
            grid-template-columns: 0.5fr 1.5fr 1fr 1fr 1fr 1fr;
        `,
    },
    total: {
        css: css`
            grid-column: 6/ 7;
        `,
    },
    surcharges: {
        css: css`
            grid-column: 5/ 6;
            padding: 8px 0;
            border-right: 1px solid ${color("common.border")};
        `,
    },
};
summaryTableStyles.groupTitle = {
    ...xOrderInformationStyles.groupLines?.groupTitle,
};

summaryTableStyles.groupWrapper = {
    ...xOrderInformationStyles.groupLines?.groupWrapper,
};
